(() => {
  function placeConsentBanner() {
    const banner = document.getElementById('shopify-pc__banner');
    const footer = document.querySelector('.mf-footer .mf-wrap');
    if (banner && footer && banner.parentElement !== footer) footer.append(banner);
  }
  placeConsentBanner();
  const consentObserver = new MutationObserver(placeConsentBanner);
  consentObserver.observe(document.body, { childList: true });
  document.addEventListener('shopify:section:load', placeConsentBanner);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-mf-cookie]');
    if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    window.privacyBanner.showPreferences().catch(() => window.location.assign(link.href));
  });
})();
